import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import { TextCensor } from '../../Components/Censor';
import './NewsHeaderStrip.scss';

const dateFormatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' });

interface NewsHeaderStripProps {
    strip: Strip;
}

export function NewsHeaderStrip({ strip: { params } }: NewsHeaderStripProps): ReactElement {
    // @todo define type
    const { title, publishDate, url } = params as { title: string; publishDate: string; url: string };
    return (
        <div className='NewsHeaderStrip'>
            <h1>
                <TextCensor text={title} />
            </h1>
            <div className='NewsHeaderStrip-poster'>
                {publishDate && (
                    <div className='NewsHeaderStrip-publishDate'>{dateFormatter.format(new Date(publishDate))}</div>
                )}
                <img src={url} alt={title} className='NewsHeaderStrip-image' />
            </div>
        </div>
    );
}
